<ion-header [translucent]="true">
  <ion-toolbar color="primary" class="modern-toolbar">
    <ion-button slot="start" size="small" routerLink="/" class="learn-button">
      <ion-icon name="book-outline"></ion-icon>
      <span style="margin-left: 8px">{{ 'Learn' | translate }}</span>
    </ion-button>

    <!-- Clear Button (Visible only in freeflow mode) -->
    <ion-button *ngIf="mainSegment === 'sentence' && sentenceSubSegment === 'freeflow'" slot="end" size="small" (click)="clearConversation()" class="clear-button">
      <ion-icon name="trash-outline"></ion-icon> {{ 'Clear' | translate }}
    </ion-button>

    <!-- Main segment -->
    <div class="main-segment-container">
      <ion-segment [(ngModel)]="mainSegment" (ionChange)="onMainSegmentChange($event)" class="main-segment">
        <ion-segment-button value="word" class="main-segment-button">
          <div class="segment-content">
            <div class="icon-wrapper">
              <ion-icon name="text-outline"></ion-icon>
            </div>
            <ion-label>{{ 'Word' | translate }}</ion-label>
          </div>
        </ion-segment-button>
        <ion-segment-button value="sentence" class="main-segment-button">
          <div class="segment-content">
            <div class="icon-wrapper">
              <ion-icon name="chatbubbles-outline"></ion-icon>
            </div>
            <ion-label>{{ 'Sentence' | translate }}</ion-label>
          </div>
        </ion-segment-button>
      </ion-segment>
    </div>
  </ion-toolbar>

  <!-- Sub-segment for words -->
  <div *ngIf="mainSegment === 'word'" class="sub-segment-container">
    <ion-segment [(ngModel)]="wordSubSegment" (ionChange)="onWordSubSegmentChange($event)" class="sub-segment">
      <ion-segment-button value="uyir" class="sub-segment-button">
        <div class="pill-content">
          <ion-label>{{ 'Vowels' | translate }}</ion-label>
        </div>
      </ion-segment-button>
      <ion-segment-button value="mei" class="sub-segment-button">
        <div class="pill-content">
          <ion-label>{{ 'Consonants' | translate }}</ion-label>
        </div>
      </ion-segment-button>
    </ion-segment>
  </div>

  <!-- After the main segment -->
  <div *ngIf="mainSegment === 'sentence'" class="sub-segment-container">
    <ion-segment [(ngModel)]="sentenceSubSegment" (ionChange)="onSentenceSubSegmentChange($event)" class="sub-segment">
      <ion-segment-button value="phrases" class="sub-segment-button">
        <div class="pill-content">
          <ion-label>{{ 'Phrase' | translate }}</ion-label>
        </div>
      </ion-segment-button>
      <ion-segment-button value="freeflow" class="sub-segment-button">
        <div class="pill-content">
          <ion-label>{{ 'Speech' | translate }}</ion-label>
        </div>
      </ion-segment-button>
    </ion-segment>
  </div>
</ion-header>

<ion-content [fullscreen]="true" class="modern-content">
  <!-- Letter Practice Mode -->
  <div *ngIf="mainSegment === 'word'" class="practice-container letter-mode">
    <div class="letter-card" [class.correct]="isCorrect" [@pulseAnimation]="isCorrect">
      <div class="letter-display">
        <div class="current-letter">{{ currentLetter?.letter || '' }}</div>
        <div class="letter-info">
          <div class="tamil-word" [@fadeInUp]>
            {{ currentLetter?.word || '' }}
            <!-- Add speaker icon for word -->
            <ion-icon name="volume-high-outline" 
                      class="audio-icon" 
                      (click)="playCurrentAudio()">
            </ion-icon>
          </div>
                    <!-- Transliteration container-->
  <div class="transliteration-container" *ngIf="romanTransliteration">
    <div class="transliteration-pill">
      <span class="transliteration-text">{{romanTransliteration}}</span>
    </div>
  </div>
          <div class="word-meaning" *ngIf="currentLetter?.meaning" [@fadeInUp]>
            {{ currentLetter?.meaning }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sentence Practice Mode -->
  <div *ngIf="mainSegment === 'sentence'" class="practice-container sentence-mode">
    <!-- Free Flow Mode -->
    <div *ngIf="sentenceSubSegment === 'freeflow'" class="chat-container">
      <div class="messages-wrapper">
        <!-- Add welcome message -->
        <div *ngIf="getFilteredConversationHistory().length === 0" class="message-item">
          <div class="message-content">
            <div class="message-bubble">
              {{ 'Speak freely in Tamil. Your speech will appear here.' | translate }}
            </div>
          </div>
        </div>
        <div *ngFor="let message of getFilteredConversationHistory()" 
             class="message-item" 
             [class.user-message]="message.isUser"
             [@messageAnimation]>
          <div class="message-content">
            <div class="message-bubble">
              {{ message.text }}
              <!-- Add transliteration for messages -->
              <div class="transliteration-container" *ngIf="message.transliteration">
                <div class="transliteration-pill">
                  <span class="transliteration-text">{{message.transliteration}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Phrases Mode -->
    <div *ngIf="sentenceSubSegment === 'phrases'" class="practice-container phrase-mode">
      <div class="phrase-card" [class.correct]="isCorrect" [@pulseAnimation]="isCorrect">
        <div class="phrase-display">
          <div class="phrase-text">
            {{ currentPhrase?.tamil || '' }}
            <!-- Add speaker icon for phrase -->
            <ion-icon name="volume-high-outline" 
                      class="audio-icon" 
                      (click)="playCurrentAudio()">
            </ion-icon>
          </div>
          <div class="phrase-info">
            <div class="transliteration-container" *ngIf="romanTransliterationPhrase">
              <div class="transliteration-pill">
                <span class="transliteration-text">{{romanTransliterationPhrase}}</span>
              </div>
            </div>
            <div class="meaning-container" [@fadeInUp]>
              <span class="meaning-text">{{ currentPhrase?.meaning || '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Simplified Controls -->
  <div class="controls-container" [@slideUpAnimation]>
    <ion-button (click)="handleMainButton()"
                [color]="getButtonColor()"
                expand="block"
                class="action-button"
                [class.recording]="isRecording">
      <ng-container *ngIf="!isRecording">
        <ion-icon name="mic" slot="start"></ion-icon>
        <span class="button-text">{{ 
          isProcessing ? ('Processing...' | translate) :
          isListening ? ('Listening...' | translate) :
          mainSegment === 'word' ? ('Speak this word' | translate) : 
          (sentenceSubSegment === 'phrases' ? ('Speak this phrase' | translate) : ('Speak a sentence' | translate)) 
        }}</span>
        <ion-icon [name]="useGoogleCloud ? 'cloud' : 'mic-circle-outline'" slot="end"></ion-icon>
      </ng-container>
      <ng-container *ngIf="isRecording">
        <div class="recording-indicator">
          <div class="wave-bars" *ngIf="!isProcessing">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
          <span>{{ isProcessing ? ('Processing...' | translate) : ('Listening...' | translate) }}</span>
        </div>
      </ng-container>
    </ion-button>
  </div>
</ion-content>

<ion-footer>
  <div class="ion-text-center footer-style">
    <span>© 2025 TAMIL.MY · <a href="https://otpam.com" target="_blank" class="footer-link">OTPAM SDN BHD (1446394-V).</a> All Rights Reserved.</span>
  </div>     
</ion-footer>